<div *ngIf="form?.controls"
     class="component-container">
  <form
    [formGroup]="form"
    class="flex flex-col w-full  md:gap-0"
  >
    <div class="row flex flex-col md:flex-row gap-[2rem] w-full">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['firstName']"
        [maxLength]="validation.user.firstName.length.max"
        [minLength]="validation.user.firstName.length.min"
        [parentFormGroup]="form"
        class="input w-full md:w-1/2"
        controlName="firstName"
        label="First Name"
        placeholder="First Name"
        type="small"
      ></app-text-input>
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['lastName']"
        [maxLength]="validation.user.lastName.length.max"
        [minLength]="validation.user.lastName.length.min"
        [parentFormGroup]="form"
        class="input w-full md:w-1/2"
        controlName="lastName"
        label="Last Name"
        placeholder="Last Name"
        type="small"
      ></app-text-input>
    </div>
    <div class="row flex flex-col md:flex-row gap-[2rem] w-full">
      <app-text-input
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['emailId']"
        [maxLength]="validation.email.length.max"
        [parentFormGroup]="form"
        class="input w-full md:w-1/2"
        controlName="emailId"
        label="Email"
        placeholder="user@mail.com"
        type="small"
      ></app-text-input>
      <div class="flex flex-col md:w-1/2">
        <div
          class="username w-full flex flex-row justify-center items-center gap-[2rem] md:gap-[1rem]">
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['username']"
            [maxLength]="null"
            [minLength]="validation.user.username.length.min"
            [ngClass]="{'hide': !displayErrorField}"
            [parentFormGroup]="form"
            [suffixIcon]="displayMessage && verifyStatusIcon"
            class="input-username w-[65%]"
            controlName="username"
            label="Username"
            placeholder="Username"
            type="small"
            inputRestriction="noUpperCaseAlphabets"
            tooltipText="Only lower case characters allowed."
          />
          <div class="action-section w-[35%]">
            <app-primary-button
              (handleClick)="autoGenerateUsername()"
              *ngIf="!form.controls['username'].value; else verify"
              [isDisabled]="!form.controls['firstName'].value || !form.controls['lastName'].value"
              [isLoading]="usernameStatusLoading"
              [ngClass]="{'hide': !displayErrorField}"
              class="input-btn w-full mb-[0] xs:mb-[0.5rem] md:mb-[0]"
              type="small"
            >
              Autogenerate
            </app-primary-button>
            <ng-template #verify>
              <app-primary-button
                (handleClick)="verifyUsername()"
                [isDisabled]="isVerifyDisabled || generatedUsername == form.controls['username'].value"
                [isLoading]="usernameStatusLoading"
                [ngClass]="{'hide': !displayErrorField}"
                class=" input-btn w-full mb-[0] xs:mb-[0.5rem] md:mb-[0]"
                type="small"
              >
                Verify
              </app-primary-button>
            </ng-template>
          </div>
        </div>
        <div class="flex w-full">
          <div
            *ngIf="displayMessage"
            class="row flex flex-row w-full space-x-[2rem] justify-start items-center"
          >
            <div
              *ngIf="usernameStatusLoading; else loaded"
              class="loading text"
            >
              Loading...
            </div>
            <ng-template #loaded>
              <div
                *ngIf="isUsernameAvailable; else displayError"
                class="success flex flex-row justify-center items-center space-x-[0.5rem]"
              >
                <app-icon
                  svgIcon="check-circle"
                ></app-icon>
                <div class="text">Username is available</div>
              </div>

              <ng-template #displayError>
                <div
                  class="error flex flex-row justify-center items-center space-x-[0.5rem]"
                >
                  <app-icon
                    svgIcon="exclamation-circle"
                  ></app-icon>
                  <div class="text">Username is not available</div>
                </div>
              </ng-template>
            </ng-template>
          </div>
        </div>
      </div>
    </div>

    <div class="row flex flex-row space-x-[2.5rem] w-full">
      <app-date-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['dob']"
        [max]="maxDobDate"
        [min]="minDobDate"
        [parentFormGroup]="form"
        class="input w-full md:w-[49%]"
        controlName="dob"
        label="Date of Birth"
        placeholder="Select a date"
        type="small"
      ></app-date-picker>
    </div>
    <div class="row flex flex-row space-x-[2.5rem] w-full">
      <app-check-box-input
        [error]="errorMessages['isLar']"
        [parentFormGroup]="form"
        controlName="isLar"
        label="Legally Authorized Representative"
        type="small"
      ></app-check-box-input>
    </div>
  </form>
</div>
